import { Plugin } from 'xgplayer'
import { navigatorLang } from '@/utils/lang'
import { getBrowser } from './browser'

const { POSITIONS } = Plugin

const playerRates = [1, 1.5, 2];

// playerRatePlugin.js
export default class playerRatePlugin extends Plugin {
    defaultRate = 1; // 默认播放速度
    rateIndex = 0; // 当前播放速度索引
    static get pluginName() {
        return 'playerRatePlugin'
    }

    static get defaultConfig() {
        return {
            position: POSITIONS.CONTROLS_RIGHT,
            index: 1
        }
    }

    constructor(args) {
        super(args)
    }

    beforePlayerInit() {
    }

    afterPlayerInit() {
    }

    afterCreate() {
        this.onClick = (event) => {
            this.rateIndex = (this.rateIndex + 1) % playerRates.length;
            const newRate = playerRates[this.rateIndex];
            // this.player.setAttribute('playbackRate', newRate);
            this.player.playbackRate = newRate;
            // 文案保留一位小数点
            let language = __tci18n_locale__;
            if (getBrowser().isMobile === true || getBrowser().isInTocaApp === true) {
                // 移动端or端内打开，跟随系统语言
                language = navigatorLang[navigator.language] || 'zh-cn';
            }
            if (language === 'en-us') {
                event.target.innerText = `${newRate.toFixed(1)}x`;
            }
            else {
                event.target.innerText = `${newRate.toFixed(1)} 倍`;
            }
        }
        this.bind('click', this.onClick)
    }

    destroy() {
        this.unbind('click', this.onClick)
        this.icon = null
    }

    render() {
        let language = __tci18n_locale__;
        if (getBrowser().isMobile === true || getBrowser().isInTocaApp === true) {
            // 移动端or端内打开，跟随系统语言
            language = navigatorLang[navigator.language] || 'zh-cn';
        }
        if (language === 'en-us') {
            return `<div class="playerRatePlugin">Speed</div>`
        }
        else {
            return `<div class="playerRatePlugin">倍速</div>`
        }
    }
}